/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';

const tableHeaderStyle = {
  padding: '12px 15px',
  border: `1px solid ${Colors.blue3}`,
  backgroundColor: Colors.blue3,
};

const tableHeaderText = {
  fontSize: 14,
  color: Colors.white,
};

const tableColumnSticky = {
  minWidth: 150,
  position: 'sticky',
  left: 0,
  zIndex: 1,
};

const TableHeader = ({
  prefixHeader = '',
  tableHeader = [],
  customSalesTargetHeader = '',
}) => {
  return (
    <thead>
      {tableHeader?.length ? (
        <>
          {tableHeader.map((item, idx) => (
            <tr key={idx}>
              {item?.length ? (
                <>
                  {item.map((child, childIdx) => (
                    <th
                      rowSpan={child['rowSpan'] || 1}
                      colSpan={child['colSpan'] || 1}
                      style={{
                        ...tableHeaderStyle,
                        ...(idx == 0 && childIdx == 0 ? tableColumnSticky : {}),
                        ...(child.body == 'salesman_code' ||
                        child.body == 'salesman_name' ||
                        child.body == 'brand'
                          ? { textAlign: 'left' }
                          : {}),
                        border: `1px solid ${Colors.grey0}`,
                      }}
                      key={childIdx}>
                      {customSalesTargetHeader?.['body'] == child?.['body'] ? (
                        <SociollaText type="medium" style={tableHeaderText}>
                          {customSalesTargetHeader['label']}
                        </SociollaText>
                      ) : (
                        <SociollaText type="medium" style={tableHeaderText}>
                          {child['label']}{' '}
                          {idx == 0 && childIdx == 0 && prefixHeader
                            ? prefixHeader
                            : ''}
                        </SociollaText>
                      )}
                    </th>
                  ))}
                </>
              ) : (
                false
              )}
            </tr>
          ))}
        </>
      ) : (
        false
      )}
    </thead>
  );
};

export default React.memo(TableHeader, (prev, next) => prev == next);
